module.exports = __webpack_public_path__ + "static/media/pk.98bf7dd1.svg";